import { render, staticRenderFns } from "./provinceManage.vue?vue&type=template&id=81540482&scoped=true&"
import script from "./provinceManage.vue?vue&type=script&lang=js&"
export * from "./provinceManage.vue?vue&type=script&lang=js&"
import style0 from "./provinceManage.vue?vue&type=style&index=0&id=81540482&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81540482",
  null
  
)

export default component.exports